import React from 'react';
import ExternalLink from '../../ui/externalLink/externalLink';
import Button from '../../ui/button/button';
import Checkbox from '../../ui/checkbox/checkbox';
import Input from '../../ui/inputs/inputs';
import { classnames } from '../../../../utils/classnames';
import './card.css';

export default function Card({title, description, onSubmit, onClick, externalLinkText, icon, checkbox, cta, ctaLabel, cancelLabel, submitLabel, input, externalLink, onChange = () => {}}) {
    const [inputValue, setInputValue] = React.useState('');

    const onChangeInputValue = React.useCallback(({ target: { value } }) => {
        setInputValue(value);
    }, []);

    return (
        <div className='neo-card-container'>
            <div className='neo-card-content'>
                <div className='neo-icon-and-title'>
                    {icon && <>{icon}</>}
                    {checkbox && <Checkbox onChange={onChange}/>}
                    <div className={classnames('neo-title-and-description', {'with-checkbox': checkbox})}>
                        <h3 className='neo-title'>{title}</h3>
                        <p className='neo-description'>{description}</p>
                    </div>
                </div>
                {
                    cta && (
                        <div className='neo-button-container'>
                            <Button 
                                onClick={onClick}
                                label={ctaLabel}
                                type='inverted-secondary'
                            />
                        </div>
                    )
                }
            </div>
            {
                externalLink && (
                    <div className='neo-external-link'>
                        <ExternalLink 
                            href={externalLink}
                            text={externalLinkText}
                        />
                    </div>
                )
            }
            {
                input && (
                    <div className='neo-input-container'>
                        <Input className='neo-card-input' value={inputValue} onChange={onChangeInputValue}/>
                        <div className='neo-cta-group'>
                            <Button 
                                onClick={onSubmit}
                                label={submitLabel}
                                className='neo-input-primary-button'
                            />
                            <Button 
                                onClick={onClick}
                                label={cancelLabel}
                                type='inverted-secondary'
                            />
                        </div>
                    </div>
                )
            }
        </div>
    )
}